export const STATUS = {
  draft: { label: "Bozza", cls: "bg-beige text-ink" },
  scheduled: { label: "Programmato", cls: "bg-amber-100 text-amber-900" },
  processing: { label: "In elaborazione", cls: "bg-blue-100 text-blue-900" },
  published: { label: "Pubblicato", cls: "bg-green-100 text-green-900" },
  error: { label: "Errore", cls: "bg-red-100 text-red-900" },
};

export const LABELS = [["", "Nessuna"], ["before", "Prima"], ["after", "Dopo"], ["render", "Render"]];
export const VARIANTS = { before_after: "Prima / Dopo", renders: "Render", gallery: "Galleria", article: "Articolo", book: "Libro" };

export const fmtRome = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const Badge = ({ status }) => <span data-testid={`ig-status-${status}`} className={`inline-block px-2 py-0.5 rounded text-[11px] font-medium ${STATUS[status]?.cls || ""}`}>{STATUS[status]?.label || status}</span>;
